export default __webpack_public_path__ + "static/media/0.ed21ae92.png";